// extracted by mini-css-extract-plugin
export var content_wrap = "whyService-module--content_wrap--dad9d";
export var inner_tab_content = "whyService-module--inner_tab_content--46ed9";
export var tab_content_wrap = "whyService-module--tab_content_wrap--b4ceb";
export var tab_list_wrap = "whyService-module--tab_list_wrap--748a8";
export var title_icon = "whyService-module--title_icon--c6de2";
export var title_wrap = "whyService-module--title_wrap--94104";
export var why_service_content_wrap = "whyService-module--why_service_content_wrap--61695";
export var why_service_section = "whyService-module--why_service_section--93167";
export var why_service_tab_wrap = "whyService-module--why_service_tab_wrap--13ace";
export var why_service_title = "whyService-module--why_service_title--28c84";